import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import Autocomplete from "@mui/material/Autocomplete";
import MKInputRoot from "../MKInputRoot";

const MKAutoSuggest = forwardRef(
  (
    {
      error,
      disabled,
      textTransform,
      options,
      minSearchLength,
      value,
      onChange,
      label,
      freeSolo,
      ...rest
    },
    ref
  ) => {
    const filterOptions = (opts, state) => {
      if (state.inputValue.length < minSearchLength) return [];
      return opts.filter((opt) =>
        opt.toLowerCase().includes(state.inputValue.toLowerCase())
      );
    };

    return (
      <Autocomplete
        ref={ref}
        freeSolo={freeSolo}
        forcePopupIcon={false}
        disableClearable
        disabled={disabled}
        options={options}

        inputValue={freeSolo ? value : undefined}
        onInputChange={(event, newInputValue, reason) => {
          if (!freeSolo) return;
          let finalValue = newInputValue || "";
          if (textTransform === "uppercase") finalValue = finalValue.toUpperCase();
          if (textTransform === "lowercase") finalValue = finalValue.toLowerCase();
          onChange?.(finalValue, reason);
        }}

        value={freeSolo ? undefined : value}
        onChange={(event, newValue, reason) => {
          let finalValue = (newValue ?? "") || "";
          if (textTransform === "uppercase") finalValue = finalValue.toUpperCase();
          if (textTransform === "lowercase") finalValue = finalValue.toLowerCase();
          onChange?.(finalValue, reason);
        }}

        filterOptions={filterOptions}
        renderInput={(params) => (
          <MKInputRoot
            {...params}
            ownerState={{ error, disabled }}
            error={error}
            disabled={disabled}
            label={label || "Auto Suggest"}
            sx={{
              "& .MuiOutlinedInput-root .MuiOutlinedInput-input": {
                paddingBottom: "0 !important",
                paddingTop: "0 !important",
              },
              "& .MuiFormLabel-root.Mui-error": {
                color: "inherit",
              },
              "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
                borderColor: "inherit",
              },
            }}
          />
        )}
        {...rest}
      />
    );
  }
);

MKAutoSuggest.defaultProps = {
  error: false,
  disabled: false,
  textTransform: undefined,
  options: [],
  minSearchLength: 2,
  label: undefined,
  value: "",
  onChange: undefined,
  freeSolo: true,
};

MKAutoSuggest.propTypes = {
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  textTransform: PropTypes.oneOf(["uppercase", "lowercase", undefined]),
  options: PropTypes.arrayOf(PropTypes.string),
  minSearchLength: PropTypes.number,
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  freeSolo: PropTypes.bool,
};

export default MKAutoSuggest;
